import { atom, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { IOfficeDetails } from "../types";

export const officeAddState = atom({
  key: "officeAddState",
  default: false,
});
export const officeEditState = atom({
  key: "officeEditState",
  default: false,
});
export const officeShowState = atom({
  key: "officeShowState",
  default: false,
});

export const officeIdValue = atom({
  key: "officeId",
  default: 0,
});
export const franchiseCheckBox = atom({
  key: "franchiseCheckBox",
  default: false,
});
export const confieCheckBox = atom({
  key: "confieCheckBox",
  default: false,
});
export const officeTimeList = atom({
  key: "officeTimeList",
  default: [],
});
export const rowForEditOfficeSettings = atom<IOfficeDetails | undefined>({
  key: "rowForEditOfficeSettings",
  default: undefined,
});
export const linkedRow = atom({
  key: "linkedRow",
  default: undefined,
});
export const officeSearchData = atom({
  key: "officeSearchData",
  default: {
    OfficeId: "",
    OfficeCode: "",
    OfficeName: "",
    OfficeStatus: "",
    SelectedOfficeStatus: "",
    OfficeTypes: "",
    SelectedOfficeTypes: "",
    StoreNumber: "",
    GLBranch: "",
    selectedGLBranch: null,
    AgencyName: "",
    Address: "",
    City: "",
    ZipCode: "",
    State: "",
    SelectedState: [],
    TargetSystem: "",
    SelectedTargetSystem: [],
    ProducerCode: "",
    Brand: "",
    BrandName: "",
    Carriers: [],
    SelectedCarrier: [],
    IsFranchise: null,
    IsConfie: false,
    Channel: "",
    SelectedChannel: null,
    Phone: "",
    ChannelId: null,
  },
});

export const getOffices = atom({
  key: "getOffices",
  default: { data: [], isLoading: false, isSuccess: false },
});

export const officesOptions = atom({
  key: "officesOptions",
  default: [],
});

export const officeViewData = atom<any>({
  key: "officeViewData",
  default: undefined,
});

export const officeFromOH = atom({
  key: "officeFromOH",
  default: false,
});

export const openRelatedOfficeState = atom({
  key: "openRelatedOfficeState",
  default: false,
});

export const workFromHome = atom({
  key: "workFromHome",
  default: false,
});

export const onchangeOfc = atom({
  key: "onchangeOfc",
  default: false,
});

export const verifiedAddress = atom({
  key: "verifiedAddress",
  default: false,
});

export const officeEligibleForOpen = atom({
  key: "officeEligibleForOpen",
  default: false,
});

export const officeFilterParams = atom({
  key: "officeFilterParams",
  default: false,
});

export const officeTimeZones = atom({
  key: "officeTimeZones",
  default: undefined,
});

export const officeVendorAddState = atom({
  key: "officeVendorAddState",
  default: false,
});
export const officeVendorEditState = atom({
  key: "officeVendorEditState",
  default: false,
});

export const OfficeVendorSvcOfficeId = atom({
  key: "OfficeVendorSvcOfficeId",
  default: undefined,
});

export const OfficeVendorSvcViewData = atom({
  key: " OfficeVendorSvcViewData",
  default: undefined,
});

export const OfficeVendorModal = atom({
  key: " OfficeVendorModal",
  default: false,
});

export const resetOfficeVendorForm = atom({
  key: " resetOfficeVendorForms",
  default: false,
});
export const DisableOfficeField = atom({
  key: " DisableOffice",
  default: false,
});

export const DisableVendorField = atom({
  key: " DisableVendorField",
  default: false,
});

export const selectedRowsStateOfcVendor = atom({
  key: "selectedRowsStateOfcVendor",
  default: [],
});

export const officeVendorViewFromOffice = atom({
  key: "officeVendorViewFromOffice",
  default: false,
});

//Address Not Required For Office Type Below:
export const officeTypeAddressNotRequired = atom({
  key: "officeTypeAddressNotRequired",
  default: ["Operations", "Shell Office", "Virtual Office", "Web Office"],
});

export const officeFromReports = atom({
  key: "officeFromReports",
  default: false,
});

export const scorecardReportsDaily = atom({
  key: "scorecardReportsDaily",
  default: false,
});

export const leasedEquipmentsReports = atom({
  key: "leasedEquipmentsReports",
  default: false,
});

// For Carrier Producer Code view all Modal
export const carrierProdCodeModal = atom({
  key: "carrierProdCodeModal",
  default: false,
});

export const CarrierProdCodeOfficeCode = atom({
  key: "CarrierProdCodeOfficeCode",
  default: undefined,
});

export const ofcFromVendor = atom({
  key: "ofcFromVendor",
  default: true,
});

export const testAtom = atom({
  key: "testAtom",
  default: "0",
});
export const prodCodeToOfficeId = atom({
  key: "prodCodeToOfficeId",
  default: null,
});

export const officeBLP = atom({
  key: "officeBLP",
  default: [],
});

export const officeVendor = atom({
  key: "officeVendor",
  default: [],
});

export const ovsFromOffice = atom({
  key: "ovsFromOffice",
  default: false,
});

export const employeeOfficeUI = atom({
  key: "employeeOfficeUI",
  default: false,
});

export const showFromEmpTable = atom({
  key: "showFromEmpTable",
  default: false,
});

export const hierarchyId = atom({
  key: "hierarchyId",
  default: null,
});

export const officeImageAttachment = atom<(File | null)[]>({
  key: "officeImageAttachment",
  default: [null],
});

export const fileImageDisplay = atom({
  key: "fileImageDisplay",
  default: [],
});

export const fileImageView = atom({
  key: "fileImageView",
  default: "",
});

export const noImageFound = atom({
  key: "noImageFound",
  default: "",
});

export const fileImageForDelete = atom({
  key: "fileImageForDelete",
  default: [],
});

export const rowImageForDelete = atom({
  key: "rowImageForDelete",
  default: [],
});

export const imageDisplays = atom({
  key: "imageDisplays",
  default: [],
});

export const changeToUpdate = atom<any>({
  key: "changeToUpdate",
  default: [],
});

export const branchManagerChanged = atom({
  key: "branchManagerChanged",
  default: false,
});

export const associatedEmployeeId = atom<number[]>({
  key: "associatedEmployeeId",
  default: [],
});

export const fromEmpReportsModal = atom({
  key: "fromEmpReportsModal",
  default: false,
});

export const disabled = atom<any>({
  key: "disabled",
  default: false,
});

export const convertedOffice = atom<boolean>({
  key: "isConvertedOffice",
  default: false,
});

export const hideEmpPagerow = atom({
  key: "hideEmpPagerow",
  default: false,
});
